import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { SERIES_QUERY_KEY, addShowToSeries } from "./api";

interface AddShowToSeriesParams {
  seriesId: string;
  showId: string;
  venuePageId: string;
}

/**
 * Hook to assign an existing show to an existing series. Idempotent at the
 * API level — re-attaching a show that's already in the series resolves
 * successfully without modifying state (204 No Content).
 */
export function useAddShowToSeries(): UseMutationResult<
  void,
  Error,
  AddShowToSeriesParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ seriesId, showId }: AddShowToSeriesParams) =>
      addShowToSeries(seriesId, showId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SERIES_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
